var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapsedArrowsLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5858 0L3.5858 8L11.5858 16H7.5858L0.295798 8.71C0.20207 8.61704 0.127676 8.50644 0.0769069 8.38458C0.0261382 8.26272 0 8.13201 0 8C0 7.86799 0.0261382 7.73728 0.0769069 7.61542C0.127676 7.49356 0.20207 7.38296 0.295798 7.29L7.5858 0H11.5858Z",
    fill: "#FFAF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.5858 0L10.5858 8L18.5858 16H14.5858L7.2958 8.71C7.20207 8.61704 7.12768 8.50644 7.07691 8.38458C7.02614 8.26272 7 8.13201 7 8C7 7.86799 7.02614 7.73728 7.07691 7.61542C7.12768 7.49356 7.20207 7.38296 7.2958 7.29L14.5858 0H18.5858Z",
    fill: "#FFAF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapsedArrowsLeft);
export default __webpack_public_path__ + "static/media/collapsed-arrows-left.ed661700edbde581cb661b4dd851e60b.svg";
export { ForwardRef as ReactComponent };